import { useSelector } from "react-redux";
import DataAccuracy from "../../../../components/AssetManagement/Health/DataAccuracy/DataAccuracy";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";

function DataAccuracyScreen() {
  const response = useSelector(selectUserData);
  const hasViewDataAnomalyPermission = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "view_data_anomalies",
  );

  return (
    <>
      {hasViewDataAnomalyPermission ? (
        <>
          <DataAccuracy />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
}

export default DataAccuracyScreen;
